module.exports = __webpack_public_path__ + "img/east-carolina-logo.51a39cbb.jpg";